import React from 'react';
import BaseCard from '@material-ui/core/Card';

const Card = (props) => <BaseCard {...props} />;

export default Card;
